// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3F6Sh","tab":"Tabs_tab__1S-xq","tabActive":"Tabs_tabActive__1cO9x"};